import React from "react";
import { ToastContainer, Slide } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import "./GlobalToast.css";

const GlobalToast = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={2500}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
      theme="light"
      transition={Slide}
      limit={4}
      toastClassName="site-toast"
      bodyClassName="site-toast-body"
      closeButton={false}
    />
  );
};

export default GlobalToast;
